import { motion } from "framer-motion";
import { CheckCircle } from "@phosphor-icons/react";
import { IMAGES } from "@/constants/site";

const POINTS = [
  "Gated township with 24×7 multi-tier security",
  "9-hole golf course & Belvedere Golf & Country Club",
  "7-acre Shantigram Lake and central landscaped greens",
  "Adani Sports Academy, schools, retail & healthcare inside",
];

export default function Overview() {
  return (
    <section id="overview" data-testid="overview-section" className="bg-cream py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 md:grid-cols-12 lg:gap-16 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="flex flex-col justify-center md:col-span-5"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-forest/70">The Township</p>
          <h2 className="mt-4 font-serif text-2xl tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            One address. An entire city within.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-slate-600">
            Spread across 600 acres near Vaishnodevi Circle on SG Highway, Adani Shantigram is Gujarat's largest
            integrated township — where homes, greens, sport, retail and leisure exist inside one private universe.
          </p>
          <ul className="mt-8 space-y-4">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3 text-sm text-slate-700">
                <CheckCircle size={20} weight="fill" className="mt-0.5 shrink-0 text-forest" />
                {p}
              </li>
            ))}
          </ul>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="relative overflow-hidden rounded-lg md:col-span-7"
        >
          <img
            src={IMAGES.township}
            alt="Adani Shantigram township architecture"
            className="h-full max-h-[560px] w-full object-cover transition-transform duration-700 hover:scale-105"
          />
          <div className="absolute bottom-0 left-0 m-6 rounded-sm bg-white/90 px-6 py-4 backdrop-blur-md">
            <p className="font-serif text-2xl text-forest">600 Acres</p>
            <p className="text-xs uppercase tracking-[0.2em] text-slate-500">Integrated Township</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
